import type { ApiLogFilterOptions } from "./types";

/**
 * Build Api Log Query Params.
 */
export function buildApiLogQueryParams(
  limit: number,
  filters?: ApiLogFilterOptions
): URLSearchParams {
  const queryParams = new URLSearchParams();
  queryParams.append("limit", limit.toString());

  if (filters?.status && filters?.status !== "all") {
    queryParams.append("status", filters.status);
  }
  if (filters?.method && filters?.method !== "all") {
    queryParams.append("method", filters.method);
  }
  if (filters?.endpoint) {
    queryParams.append("endpoint", filters.endpoint);
  }
  if (filters?.minDuration) {
    queryParams.append("minDuration", filters.minDuration.toString());
  }
  if (filters?.search) {
    queryParams.append("search", filters.search);
  }
  if (filters?.timeRange) {
    queryParams.append("timeRange", filters.timeRange);
  }
  if (filters?.gatewayOnly) {
    queryParams.append("gatewayOnly", "true");
  }

  return queryParams;
}

export function truncateApiLogBody(
  body: string | undefined | null,
  maxLength: number = 1000
): string | null {
  if (!body) return null;
  const bodyStr = typeof body === "string" ? body : JSON.stringify(body);
  if (bodyStr.length <= maxLength) return bodyStr;
  return `${bodyStr.substring(0, maxLength)}... [truncated ${bodyStr.length - maxLength} chars]`;
}
